export default "dist/images/components-columns-width-control-3-4.05211d4.png";